<template>
	<v-card-text>
		<step :step="step" />
		<v-row v-if="success" class="mt-5">
			<v-col cols="8" sm="9"
				>Pairing successful! Click next to continue...</v-col
			>
		</v-row>
		<v-row v-else-if="busy && !pairing" class="mt-5">
			<v-progress-linear indeterminate />
			<v-col cols="8" sm="9">Waiting to connect...</v-col>
		</v-row>
		<v-row v-else-if="pairing" class="mt-5">
			<v-progress-linear indeterminate />
			<v-col cols="8" sm="9">Waiting for device to pair...</v-col>
			<v-col cols="4" sm="3">
				<v-btn text color="error" @click="cancel">Cancel</v-btn>
			</v-col>
		</v-row>
		<v-row v-else-if="canceled" class="mt-5">
			<v-col cols="8" sm="9"
				>Pairing cancelled. Click retry to start again.</v-col
			>
			<v-col cols="4" sm="3">
				<v-btn text color="primary" @click="start">Retry</v-btn>
			</v-col>
		</v-row>
	</v-card-text>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import Step from "../Step";
import stepBase from "../../extends/step";
import zwaveBase from "../../extends/zwave";

export default {
	components: {
		Step,
	},

	mixins: [stepBase, zwaveBase],

	props: {
		step: Object,
	},

	data() {
		return {
			success: false,
			canceled: false,
			pairing: false,
			stepNumber: 2,
		};
	},

	methods: {
		...mapGetters({ nodeByGuid: "controller/nodes/nodeByGuid" }),
		...mapActions({ setNodeProperty: "controller/nodes/setProperty" }),

		cancel() {
			this.$log(`ZWave Wizard: Pairing cancelled`);
			this.canceled = true;
			this.setDisableNext(false);
			this.pairing = false;
			this.stop();
		},

		async start() {
			this.$log(`ZWave Wizard: Pairing started changed ${this.device.path}`);
			this.setDisableNext(true);

			// already pairing
			if (this.busy) return;

			this.setBusy(true);

			// get the zwave bridge
			let bridge = await this.getBridge();

			// TODO: show pairing instructions

			let response;
			try {
				// start the pairing
				this.pairing = true;
				response = await bridge.child("commands/addNode").execute({
					className: this.cls,
				});
				this.pairing = false;
			} catch (e) {
				if (!this.pairing || !this.busy) {
					// cancelled
					return;
				}
				this.pairing = false;

				let errorMessage = e;
				if (_.isError(e)) errorMessage = e.message;
				else if (_.isObject(e)) errorMessage = JSON.stringify(e);

				this.$log(
					`ZWave Wizard: Pairing failed for ${this.device.path} with error ${errorMessage}`
				);
				return this.showError("Pairing failed. Please try again.", true);
			}

			let { nodeid, status } = response.addData;

			if (status === "Node added.") {
				try {
					await this.setNodeProperty({
						nodeGuid: this.device.meta
							? this.device.meta.guid
							: this.device.guid,
						propName: "networkId",
						propValue: nodeid,
					});

					let name = bridge.name();
					let guid = bridge
						.parent()
						.parent()
						.guid(); // get the controller guid, so we can lookup the store device

					// TODO - in future, handle if controller has been deleted and guid doesnt match the devices list?

					let controller = this.nodeByGuid()(guid);
					if (!controller) {
						throw new Error("Controller device not found");
					}

					let path = `${controller.path}/Bridges/${name}`;
					await this.setNodeProperty({
						nodeGuid: this.device.meta
							? this.device.meta.guid
							: this.device.guid,
						propName: "bridge",
						propValue: path,
					});
					this.success = true;
					this.$log(
						`ZWave Wizard: Pairing completed for ${this.device.path} with networkId ${nodeid} and bridge ${path}`
					);
				} catch (e) {
					this.$log(
						`ZWave Wizard: Pairing failed for ${this.device.path} with response ${e}`
					);
					return this.showError(
						"Unable to complete the pairing. Unpair the device and try again."
					);
				}
			} else {
				this.$log(
					`ZWave Wizard: Pairing failed for ${
						this.device.path
					} with response ${JSON.stringify(response)}`
				);
				return this.showError("Pairing failed. Please try again.", true);
			}

			this.success = true;

			this.setDisableNext(false);

			this.setBusy(false);
		},
	},
};
</script>
